import { registerLanguage } from '../_.contribution.js';

registerLanguage({
  id: "css",
  extensions: [".css"],
  aliases: ["CSS", "css"],
  mimetypes: ["text/css"],
  loader: () => import('./css.js')
});
